import { render, staticRenderFns } from "./ACRAdminBuisnessRule.vue?vue&type=template&id=3f0a1480"
import script from "./ACRAdminBuisnessRule.vue?vue&type=script&lang=js"
export * from "./ACRAdminBuisnessRule.vue?vue&type=script&lang=js"
import style0 from "./ACRAdminBuisnessRule.vue?vue&type=style&index=0&id=3f0a1480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports